import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { DeliveryOutputDto, DeliveryService } from 'src/generated_client';
import { environment } from 'src/environments/environment';

interface PaginatedResponse<T> {
  data: T[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasPrevious: boolean;
  hasNext: boolean;
}

@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.css']
})
export class PersonalComponent implements OnInit {

  displayedColumns: string[] = ['nombre', 'telefono', 'comision', 'estado', 'horario', 'opciones'];
  allDeliveries: DeliveryOutputDto[] = [];
  pageNumber: number = 1;
  pageSize: number = 10;
  totalCount: number = 0;
  pageSizeOptions: number[] = [5, 10, 25, 50];

  constructor(
    private router: Router,
    public deliveryService: DeliveryService,
    private snackBar: SnackBarService,
    private http: HttpClient
  ) {
  }

  ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.loadCadetes();
  }

  loadCadetes(): void {
    let params = new HttpParams();
    params = params.set('pageNumber', this.pageNumber.toString());
    params = params.set('pageSize', this.pageSize.toString());

    this.http
      .get<PaginatedResponse<DeliveryOutputDto> | DeliveryOutputDto[]>(
        `${environment.apiBaseUrl}/api/Delivery/GetAll`,
        { params }
      )
      .subscribe({
        next: (response) => {
          if (Array.isArray(response)) {
            // Backward compatibility if API returns non-paginated list.
            this.allDeliveries = response;
            this.totalCount = response.length;
            return;
          }

          this.allDeliveries = response?.data || [];
          this.totalCount = response?.totalCount || 0;
          this.pageNumber = response?.pageNumber || this.pageNumber;
          this.pageSize = response?.pageSize || this.pageSize;
        },
        error: () => {
          this.snackBar.openSnackBar('No se pudieron cargar los cadetes.', 'Aceptar');
        }
      });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex + 1;
    this.loadCadetes();
  }

  addPerson() {
    this.router.navigate(['add-person']);
  }

  editPerson(id: number) {
    this.router.navigate(['edit-person', id]);
  }

  changeStatus(id: number, isActive: boolean) {
    if (isActive) {
      this.deliveryService.apiDeliveryActiveInactivePut(id, false).subscribe(response => {
        console.log(response);
        this.loadCadetes();
      }, error => {
        console.log(error)
        this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar');
      })
    } else {
      this.deliveryService.apiDeliveryActiveInactivePut(id, true).subscribe(response => {
        console.log(response);
        this.loadCadetes();
      }, error => {
        console.log(error)
        this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar');
      })
    }

  }

}

